export default "__VITE_ASSET__06d3cf39__"